import { useState } from "react";
import { FlaskConical } from "lucide-react";
import { statusApi } from "../../api/status";

export default function TestAlertButton({ serviceName, serviceType }: { serviceName: string; serviceType: string }) {
  const [state, setState] = useState("idle");

  async function fire() {
    setState("loading");
    try {
      await statusApi.testAlert(serviceName, serviceType);
      setState("sent");
      setTimeout(() => setState("idle"), 3000);
    } catch {
      setState("error");
      setTimeout(() => setState("idle"), 3000);
    }
  }

  const label = state === "loading" ? "Sending…"
    : state === "sent" ? "Sent!"
    : state === "error" ? "Failed"
    : "Test alert";

  const colours = state === "sent" ? "border-green-300 bg-green-50 text-green-700"
    : state === "error" ? "border-red-300 bg-red-50 text-red-700"
    : "border-amber-200 bg-amber-50 text-amber-700 hover:border-amber-300 hover:bg-amber-100";

  return (
    <button
      onClick={fire}
      disabled={state === "loading" || state === "sent"}
      title={`Fire a test alert for ${serviceName}`}
      className={`flex shrink-0 items-center gap-1.5 rounded-md border px-2 py-1 text-xs font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${colours}`}
    >
      <FlaskConical size={11} />
      {label}
    </button>
  );
}
